// extracted by mini-css-extract-plugin
export default {"summaryData":"Summary_summaryData__RqCWk","summary":"Summary_summary__PMsbg","summaryValue":"Summary_summaryValue__62uFa"};